class FailedToNavigateViaCJScriptError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FailedToNavigateViaCJScriptError';
  }
}

export default FailedToNavigateViaCJScriptError;
